"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createRequest = exports.FetchProvider = void 0;
var jinqu_1 = require("jinqu");
var FetchProvider = /** @class */ (function () {
    function FetchProvider() {
    }
    FetchProvider.prototype.ajax = function (o) {
        if (o.params && o.params.length) {
            o.url += "?" + o.params.map(function (p) { return p.key + "=" + encodeURIComponent(p.value); }).join("&");
        }
        var promise = fetch(o.url, createRequest(o))
            .then(function (r) {
            return r.json()
                .then(function (d) { return ({ value: d, response: r }); });
        });
        if (!o.timeout) {
            return promise;
        }
        return Promise.race([
            promise,
            new Promise(function (_, reject) {
                return setTimeout(function () { return reject(new Error("Request timed out")); }, o.timeout);
            }),
        ]);
    };
    FetchProvider.defaultOptions = {
        headers: {
            "Accept": "application/json; charset=utf-8",
            "Content-Type": "application/json; charset=utf-8",
        },
        method: "GET",
    };
    return FetchProvider;
}());
exports.FetchProvider = FetchProvider;
function createRequest(o) {
    var d = Object.assign({}, FetchProvider.defaultOptions);
    o = jinqu_1.mergeAjaxOptions(d, o);
    return {
        body: JSON.stringify(o.data),
        headers: o.headers,
        method: o.method,
    };
}
exports.createRequest = createRequest;
//# sourceMappingURL=fetch-provider.js.map